import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from '@uzurv/afp/button';
import { PersonSuspensionDetail } from '@uzurv/clara';
import { PersonSuspensionCardComponent } from './person-suspension-card/person-suspension-card.component';

@Component({
  selector: 'app-person-suspension',
  templateUrl: './person-suspension.component.html',
  styleUrls: ['./person-suspension.component.scss'],
  imports: [CommonModule, ButtonModule, PersonSuspensionCardComponent],
  standalone: true
})
export class PersonSuspensionComponent {
  @Input() personSuspensions: Array<PersonSuspensionDetail>;
  @Input() hasCreatePermission = false;
  @Input() hasPermanentRemovePermission = false;
  @Input() hasTemporaryRemovePermission = false;
  @Output() createSuspension = new EventEmitter<void>();
  @Output() removeSuspension = new EventEmitter<PersonSuspensionDetail>();

  getSortedPersonSuspensionsEffectiveAtDescending(): Array<PersonSuspensionDetail> {
    return (
      this.personSuspensions?.sort((a, b) => {
        const dateA = new Date(a.effectiveAt).getTime();
        const dateB = new Date(b.effectiveAt).getTime();
        return dateB - dateA;
      }) || []
    );
  }

  getRemoveSuspensionPermission(suspension: PersonSuspensionDetail): boolean {
    if (suspension?.suspensionReason?.permanent) {
      return this.hasPermanentRemovePermission;
    }
    return this.hasTemporaryRemovePermission;
  }

  handleCreateSuspension(): void {
    this.createSuspension.emit();
  }

  handleRemoveSuspension(suspension: PersonSuspensionDetail): void {
    this.removeSuspension.emit(suspension);
  }
}
